import { AbstractService } from '../superclasses/abstract-service';
import { apiConfig } from '../config/api.config';
import { AxiosRequestConfig } from 'axios';
import { CompanyRoleSearchItem } from '@/interfaces/search/company-role-search-item';
import { ProcurementSearchItem } from '@/interfaces/search/procurement-search-item';

const api = '/search-items';

export class SearchItemService extends AbstractService {

  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  public getProcurementsByProjectId = async (projectId: number, limit?: number): Promise<ProcurementSearchItem[]> => {
    const response = await this.get<ProcurementSearchItem[]>(`${api}/procurements/by-project/${projectId}`, { params: { limit: limit } });
    return this.getResponse(response);
  }

  public getCompanyRolesByCompanyId = async (companyId: number, limit?: number): Promise<CompanyRoleSearchItem[]> => {
    const response = await this.get<CompanyRoleSearchItem[]>(`${api}/company-roles/by-company/${companyId}`, { params: { limit: limit } });
    return this.getResponse(response);
  }
}

export const searchItemService = new SearchItemService(apiConfig);